import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import StudentContinuumDetails from "./routes/StudentContinuumDetails";
import ViewContinuum from "./routes/ViewContinuum";
export default store => ({
  path: ":continuum_id",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "continuum" */ "./components"),
        import(
          /* webpackChunkName: "continuum" */ "Continuum/modules/ContinuumModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "continuum",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [ViewContinuum(store), StudentContinuumDetails(store)],
});
